export const siteDetailsTabKeys = {
  Overview: "1",
  Optimizations: "2",
  Forecasters: "3",
  "Site Configuration": "4",
  Transactions: "5",
  Validation: "6",
  Settings: "7",
  Profiles: "8",
  "OCPP Broker": "9",
  "Schedule Following": "10",
  Controller: "11",
  "Site IO Configuration": "12",
  O11y: "13",
  "Failed Messages": "14",
  Predictions: "15",
  "OCPP Messages": "16",
  Drivers: "17",
};
